import { render } from "./CustomerStory.vue?vue&type=template&id=7ae8982f"
import script from "./CustomerStory.vue?vue&type=script&lang=js"
export * from "./CustomerStory.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__